import { Hub } from 'aws-amplify/utils';
import { AuthEvent, AuthHub } from './AuthHub';

export const startAuthHubAdapter = (): (() => void) =>
  Hub.listen('auth', ({ payload }) => {
    AuthHub.dispatch(payload as AuthEvent);
  });
